package io.horion.cv.api.repository.payement

import io.horion.cv.api.config.HttpClient
import io.horion.cv.api.datasource.Endpoint
import io.horion.cv.api.datasource.payement.PaymentRequest
import io.horion.cv.api.datasource.response.Response
import io.horion.cv.api.datasource.response.SessionsResponse
import io.horion.cv.api.utils.Constants.CV_API_URL
import io.horion.cv.api.utils.Constants.PAY_URL
import io.ktor.client.call.body
import io.ktor.client.request.accept
import io.ktor.client.request.get
import io.ktor.client.request.headers
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import io.ktor.http.isSuccess
import kotlinx.browser.window

class PayRepositoryImpl: PayRepository {

    override suspend fun payement(pay : PaymentRequest): Response {
        return try {
            val response: HttpResponse = HttpClient.client.post("$PAY_URL${Endpoint.Payment.path}") {
                contentType(ContentType.Application.Json)
                accept(ContentType.Application.Json)
                setBody(pay)
            }

            if (response.status.isSuccess()) {
                response.body<Response>()
            } else {
                Response(
                    success = false,
                    message = "Erreur HTTP ${response.status.value} : Réponse non autorisée ou invalide"
                )
            }
        } catch (e: Exception) {
            Response(
                success = false,
                message = e.message ?: "Erreur réseau"
            )
        }
    }

    override suspend fun getCvStatus(token: String,sessionUuid: String): SessionsResponse {
        return try {
            val response: HttpResponse = HttpClient.client.get("$CV_API_URL${Endpoint.Status.path}?sessionUuid=$sessionUuid") {
                contentType(ContentType.Application.Json)
                accept(ContentType.Application.Json)
                headers {
                    append(HttpHeaders.Authorization, "Bearer $token")
                }

            }

            when (response.status) {
                HttpStatusCode.OK -> {
                    response.body<SessionsResponse>()
                }
                HttpStatusCode.BadRequest ->{
                    response.body<SessionsResponse>()
                }

                HttpStatusCode.Unauthorized ->
                    SessionsResponse(
                        success = false,
                        message = "Non autorisé"
                    )

                else ->
                    SessionsResponse(
                        success = false,
                        message = "Erreur serveur (${response.status})"
                    )
            }
        } catch (e: Exception) {
            SessionsResponse(
                success = false,
                message = e.message ?: "Erreur réseau"
            )
        }
    }

    override suspend fun DownloadCv(urlCv: String) {
        window.open(urlCv, "_blank")
    }
}